<!--
 * @Description: 分类时长统计
 * @Author: xiawenlong
 * @Date: 2021-04-22 19:49:49
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-04-23 11:51:19
-->
<template>
  <div class="card class chart">
    <div class="header">
      <div class="title">分销数据</div>
    </div>
    <div id="distributeDataCharts" class="chart"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import { GridComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([GridComponent, TitleComponent, TooltipComponent, BarChart, CanvasRenderer])

export default {
  name: 'DistributeDataCard',
  props: {
    distributeList: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartInstance: null,
    }
  },
  watch: {
    distributeList: {
      handler(newVal) {
        if (newVal && newVal.timeList && newVal.amountList) {
          this.updateChart()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    initChart() {
      const dom = document.getElementById('distributeDataCharts')
      if (!dom) return
      this.chartInstance = echarts.init(dom)
      this.updateChart()
    },
    updateChart() {
      if (!this.chartInstance) return
      const { timeList = [], amountList = [] } = this.distributeList || {}
      const option = {
        title: {
          // text: '分销趋势',
          subtext: '单位：元',
          left: 10,
          top: 0,
          textStyle: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333333',
          },
          subtextStyle: {
            fontSize: 12,
            color: '#999999',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 50,
          right: 20,
          top: 50,
          bottom: 30,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: {
            lineStyle: {
              color: '#e2e2e2',
            },
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#f0f0f0',
              type: 'dashed',
            },
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12,
          },
        },
        series: [
          {
            type: 'bar',
            data: amountList,
            barWidth: '50%',
            itemStyle: {
              color: '#4B8CFF',
              borderRadius: [2, 2, 0, 0],
            },
          },
        ],
      }
      this.chartInstance.setOption(option)
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  &.chart {
    width: calc(100% - 483px);
    height: 307px;
    .chart {
      width: 100%;
      height: 260px;
    }
    .header {
      .filter {
        display: flex;
        align-items: center;
        ul {
          display: flex;
          li {
            cursor: pointer;
            width: 45px;
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            &:first-of-type {
              margin-right: 20px;
            }
            &.active {
              color: #ff7b33;
            }
          }
        }
      }
    }
  }
}
</style>
